import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatCommonModule } from "@angular/material/core";
import { catchError, of, tap } from "rxjs";
import { AgencyContactInformation } from "../../models/agency-contact-info.model";
import { AgencyContactInfoService } from "../../services/agency-contact-info.service";
import { LookupsService } from "../../services/lookups.service";
import { DialogService } from "src/app/shared/services/dialog.service";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";

@Component({
    selector: "app-agency-contact-info",
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule,
        MatCommonModule,
    ],
    templateUrl: "./agency-contact-info.component.html",
    styleUrl: "./agency-contact-info.component.scss"
})
export class AgencyContactInfoComponent implements OnInit {
  @Input() agencyId!: string;
  @Input() pendingMode: boolean = false;
  contactInfoForm!: FormGroup;
  contactInfo!: AgencyContactInformation;
  lastModified!: string;
  emailString!: string;
  countryList: any = [];
  saved: boolean = false;
  error: boolean = false;

  constructor(
    private service: AgencyContactInfoService,
    private lookupsService: LookupsService,
    private dialogService: DialogService,
    private router: Router,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.lookupsService
      .getLookupByTableAlias("country")
      .subscribe((countries) => {
        this.countryList = countries;
        this.getContactInfo();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['agencyId'] && changes['agencyId'].currentValue) {
        this.getContactInfo();
    }
  }
  
  getContactInfo() {
    this.service
      .getAgencyContactInfo(this.agencyId)
      .subscribe((info: AgencyContactInformation) => {
        this.contactInfo = info;

        this.createFormGroup();
        this.emailString = "mailto:" + info.email;
      });
  }

  createFormGroup() {
    this.contactInfoForm = new FormGroup({
      contactTitle: new FormControl(this.contactInfo.contactTitle),
      contactName: new FormControl(this.contactInfo.contactName),
      email: new FormControl(this.contactInfo.email),
      phoneCountryCode: new FormControl(this.contactInfo.phoneCountryCode),
      phone: new FormControl(this.contactInfo.phone),
      address1: new FormControl(this.contactInfo.address1),
      address2: new FormControl(this.contactInfo.address2),
      city: new FormControl(this.contactInfo.city),
      postalCode: new FormControl(this.contactInfo.postalCode),
      state: new FormControl(this.contactInfo.state),
      country: new FormControl(this.contactInfo.country),
      phoneOld: new FormControl({
        value: this.contactInfo.phoneOld,
        disabled: true,
      }),
    });
  }

  update = () => {
    console.log(this.contactInfoForm);

    this.service
      .updateAgentProfile(this.contactInfoForm.value, this.agencyId)
      .pipe(
        tap((updateResult) => {
          // Handle success response
          this.saved = true;
          this.error = false;

          if (
            updateResult &&
            JSON.stringify(updateResult) === '{"Updated":1}'
          ) {
            this.saved = true; // This line can be redundant
          }
        }),
        catchError((err) => {
          console.log(err);
          this.error = true;
          this.saved = false;
          return of(null); // Return a null observable to complete the stream
        })
      )
      .subscribe(); // Now the subscribe is cleaner
  };
}
